import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import { Button } from '@/routes/_embaUserLayout/-components/Button';
import { LessonTitle } from '@/routes/_embaUserLayout/-components/LessonTitle';
import type React from 'react';
import timerIcon from './-assets/timer.svg';
import { QuestionListItem } from './-components/QuestionListItem';
import styles from './index.module.scss';

export const COURSE_SKILL_CHECK_TEST_QUESTION = graphql(/* GraphQL */ `
  fragment EmbaCourseSkillCheckTestQuestionListItem on SkillCheckTestQuestion {
    id
    ...EmbaCourseSkillCheckTestQuestionDetail
  }
`);

export type QuestionPageProps = {
  embaCourseName: string;
  questions: FragmentType<typeof COURSE_SKILL_CHECK_TEST_QUESTION>[];
  allQuestionsAnswered: boolean;
  remainingTimeText: string;
  handleSingleChoiceChange: (questionId: number, choiceId: number) => void;
  handleMultipleChoiceChange: (questionId: number, choiceId: number) => void;
  handleSubmit: () => Promise<void>;
  initBlocking: () => void;
  answerSkillCheckTestMutationLoading: boolean;
};

export const QuestionPage = ({
  embaCourseName,
  questions,
  allQuestionsAnswered,
  remainingTimeText,
  handleSingleChoiceChange,
  handleMultipleChoiceChange,
  handleSubmit,
  initBlocking,
  answerSkillCheckTestMutationLoading,
}: QuestionPageProps) => {
  initBlocking();
  const questionsData = questions.map((question) =>
    useFragment(COURSE_SKILL_CHECK_TEST_QUESTION, question),
  );

  return (
    <>
      <LessonTitle
        lessonName="スキルチェックテスト"
        chapterName={embaCourseName}
      />
      <div className={styles.questions}>
        <p className={styles.annotation}>
          ※一度正解した問題は全問正解するまで表示されなくなります
        </p>
        <div className={styles.remainingTime}>
          <img src={timerIcon} alt="" />
          <p>残り</p> <span>{remainingTimeText}</span>
        </div>
        <div className={styles.questionsArea}>
          <ul className={styles.questions}>
            {questionsData.map((question) => (
              <QuestionListItem
                question={question}
                key={question.id}
                handleSingleChoiceChange={handleSingleChoiceChange}
                handleMultipleChoiceChange={handleMultipleChoiceChange}
              />
            ))}
          </ul>
          <div className={styles.answerButton}>
            <Button
              onClick={() => {
                handleSubmit();
              }}
              disabled={!allQuestionsAnswered}
              loading={answerSkillCheckTestMutationLoading}
            >
              回答
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
